module.exports = __webpack_public_path__ + "img/Scratched_gold_01_1K_Normal.c78badeb.png";